export type TMetricScope = 'studio' | 'portfolio';

export interface IMetricAxisFields {
  /** Stable row id: date (studio) or studio_id (portfolio). */
  key: string;
  /** X-axis / table label: date (studio) or studio_name (portfolio). */
  label: string;
}

/**
 * Studios chart rows use `date`; Portfolio Overview rows use studio_id/studio_name.
 * Keep API `date` on the row separately for tooltips (do not replace with label).
 */
export const normalizeMetricAxisFields = (
  row: Record<string, unknown>,
  scope: TMetricScope,
): IMetricAxisFields => {
  if (scope === 'portfolio') {
    const studioId = row?.studio_id;
    const studioName = row?.studio_name;
    const key = studioId === null || studioId === undefined ? '' : String(studioId);
    const label = studioName === null || studioName === undefined || studioName === ''
      ? key
      : String(studioName);
    return { key, label };
  }

  const date = row?.date ?? row?.month;
  const key = date === null || date === undefined || date === '' ? '' : String(date);
  return { key, label: key };
};

/** Keep API order; drop rows missing an axis key. */
export const filterValidAxisRows = <T extends IMetricAxisFields>(rows: T[]): T[] => (
  rows.filter((row) => !!row.key)
);
